// extracted by mini-css-extract-plugin
export default {"modalHeader":"ModalHeader-modalHeader-THPud"};